// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"532":"082f1c3c","867":"31233110"}[chunkId] + ".chunk.css";
};